//zh.js
export default {
    index: {
        content: `拥抱视频化和智能化的未来`,
        contentInfo: '提升消费者的选购体验',
        // contentInfo:'用视频和算法提升消费者的选购体验',
        cultureTitle: '我们的文化',
        culture: '坦诚的沟通驱动高效的协作、用数据和事实捍卫观点、致力于成为别人眼中的高绩效者',
        posterTitle: '鬼手剪辑',
        poster: '一款创意剪辑工具，帮助客户打造优秀的本土视频创意。',
        go: '点此体验',
        videoTitle: '懒猫智能',
        // video: '一套自动化的系统，通过RPA和AI技术把创意的管理效率成倍提升。',
        video: '一套自动化的系统，通过RPA技术把创意的管理效率成倍提升。',
        joinTitle: '加入我们',
        // join: '把未来投入到指数级增长的世界，拥抱数据、算法和算力。一直在招聘中，欢迎有志之士加入',
        join: '把未来投入到指数级增长的世界。一直在招聘中，欢迎有志之士加入',
        company: '上海招鲤科技有限公司',
        Abbreviation: '招鲤',
        RecordInfo: '沪ICP备19019916号-2',
    }
}